<template>
  <b-modal
    ref="modal"
    :visible="true"
    static
    lazy
    centered
    no-fade
    title="Новый расход"
    hide-footer
    @hide="onHide"
    @hidden="onHidden"
  >
    <form @submit.prevent="submit" novalidate>
      <div class="exf__object mb-3"><span class="text-muted">Объект:</span> {{ location.name }}</div>
      <div class="form-group">
        <label class="small font-weight-bold text-muted" for="exf-date">Дата расхода <span class="text-danger">*</span></label>
        <date-picker
          v-model="form.expense_date"
          type="date"
          format="DD.MM.YYYY"
          value-type="YYYY-MM-DD"
          :clearable="false"
          :editable="false"
          :disabled="busy"
          :input-attr="{ id: 'exf-date' }"
          input-class="form-control form-control-sm exf__date"
          placeholder="дд.мм.гггг"
        />
      </div>
      <div class="form-group">
        <label class="small font-weight-bold text-muted" for="exf-amount">Сумма, ₽ <span class="text-danger">*</span></label>
        <input id="exf-amount" v-model="form.amount" type="number" min="0.01" step="0.01" class="form-control form-control-sm exf__amount" :disabled="busy">
      </div>
      <div class="form-group">
        <label class="small font-weight-bold text-muted" for="exf-description">Описание <span class="text-danger">*</span></label>
        <textarea id="exf-description" v-model="form.description" rows="3" class="form-control form-control-sm exf__description" :disabled="busy" :maxlength="descriptionMax"></textarea>
      </div>
      <ul v-if="errors.length" class="alert alert-danger py-2 pl-4 mb-3" role="alert">
        <li v-for="(e, i) in errors" :key="i">{{ e }}</li>
      </ul>
      <div class="d-flex justify-content-between">
        <button type="button" class="btn btn-secondary btn-sm exf__cancel" :disabled="busy" @click="hideModal">Отмена</button>
        <button type="submit" class="btn btn-success btn-sm exf__submit" :disabled="busy">
          <span v-if="busy" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>Сохранить
        </button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import * as api from '@/components/management/dispatcher/api';
import {
  DESCRIPTION_MAX, emptyExpenseForm, validateExpenseForm, buildExpensePayload,
} from '@/components/management/dispatcher/expensesPayload';
import { todayIso } from '@/components/management/dispatcher/format';
import { notifySuccess, notifyError } from '@/components/management/dispatcher/notify';
import modalCloseMixin from '@/components/management/dispatcher/map/modalCloseMixin';

/** «Добавить расход» (KOP-39 spec §6.5): one manual expense for the selected object. */
export default {
  name: 'ExpenseFormModal',
  components: { DatePicker },
  mixins: [modalCloseMixin],
  props: {
    location: { type: Object, required: true },
  },
  data() {
    return {
      form: emptyExpenseForm(todayIso()),
      errors: [],
      busy: false,
    };
  },
  computed: {
    descriptionMax() { return DESCRIPTION_MAX; },
  },
  methods: {
    async submit() {
      if (this.busy) return;
      this.errors = validateExpenseForm(this.form);
      if (this.errors.length) return;
      this.busy = true;
      try {
        const saved = await api.createLocationExpense(buildExpensePayload(this.form, this.location.id));
        notifySuccess(this, 'Расход добавлен');
        this.$emit('saved', saved);
        this.hideModal();
      } catch (e) {
        notifyError(this, e);
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.exf__object { font-size: 13px; color: #1d221f; }
</style>
